
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import AccessDenied from '@/components/admin/AccessDenied';
import { useAdminDashboard } from '@/hooks/useAdminDashboard';
import AdminDashboardContent from '@/components/admin/dashboard/AdminDashboardContent';
import AdminDialogContainer from '@/components/admin/dashboard/AdminDialogContainer';

const AdminDashboard: React.FC = () => {
  const {
    isAdmin,
    isLoading,
    selectedRequest,
    isDialogOpen,
    setIsDialogOpen,
    isAddEmployeeOpen,
    setIsAddEmployeeOpen,
    isAddClientOpen,
    setIsAddClientOpen,
    isEditClientOpen,
    setIsEditClientOpen,
    clientToEdit,
    newStatus,
    setNewStatus,
    isProcessing,
    updateRequestStatus,
    fetchEmployees,
    handleAddClient,
    updateClient
  } = useAdminDashboard();

  // Create a Promise wrapper for handleAddClient to match the expected type
  const handleAddClientAsync = async (clientData: any): Promise<void> => {
    return new Promise<void>((resolve) => {
      handleAddClient(clientData);
      resolve();
    });
  };

  console.log('Admin page - isEditClientOpen:', isEditClientOpen, 'clientToEdit:', clientToEdit);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAdmin) {
    return <AccessDenied />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Admin Dashboard - IT Management Solutions"
        description="Manage client onboarding requests and user access."
        canonicalUrl="https://itmgmtsol.com/admin"
      />
      <Navbar />

      <section className="bg-itmgmt-light-gray py-12 md:py-16">
        <div className="container-wide">
          <div className="text-center mb-10">
            <h1 className="heading-xl text-itmgmt-dark-blue mb-4">Admin Dashboard</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Manage clients, employees, newsletters, and system settings.
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="container-wide mx-auto">
          <AdminDashboardContent />
        </div>
      </section>

      <AdminDialogContainer 
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        selectedRequest={selectedRequest}
        newStatus={newStatus}
        setNewStatus={setNewStatus}
        isProcessing={isProcessing}
        updateRequestStatus={updateRequestStatus}
        isAddEmployeeOpen={isAddEmployeeOpen}
        setIsAddEmployeeOpen={setIsAddEmployeeOpen}
        fetchEmployees={fetchEmployees}
        isAddClientOpen={isAddClientOpen}
        setIsAddClientOpen={setIsAddClientOpen}
        handleAddClient={handleAddClientAsync}
        isEditClientOpen={isEditClientOpen}
        setIsEditClientOpen={setIsEditClientOpen}
        clientToEdit={clientToEdit}
        updateClient={updateClient}
      />

      <Footer />
    </div>
  );
};

export default AdminDashboard;
